import {
  Box, Image, ListItem, ListItemWithImage, Text,
} from '@domain-group/suit-theme'

import usePublication from '@hooks/usePublication'

type TodaysDeadlinesProps = {
  deadlineDate: object,
  publicationDate: object,
  publicationId: number,
  relativeDate: string | null,
  title: string,
}

const TodaysDeadlinesListItem = (props: { todaysDeadline: TodaysDeadlinesProps }) => {
  const { todaysDeadline } = props

  const {
    deadlineDate,
    publicationDate,
    publicationId,
    relativeDate,
    title,
  } = todaysDeadline

  const usePublicationPayload = usePublication({ id: publicationId })
  const { publication, publication: { logo } } = usePublicationPayload
  const imageUrl = logo?.thumb ?? ''

  // @ts-expect-error TS2339
  const convertedPublicationDate = publicationDate.toFormat('EEEE dd LLLL')

  return (
    <Box variant="white" marginBottom="large" flexDirection="column">
      <Box alignItems="center">
        <ListItemWithImage
          boxProps={{
            alignItems: 'center',
            border: 'none',
            display: 'flex',
            height: '50px',
            justifyContent: 'center',
            marginBottom: 0,
            width: '100px',
          }}
        >
          {imageUrl ? (
            <Image width={100} height={50} url={imageUrl} />
          ) : (
            <Box padding="small" justifyContent="center">
              <Text fontSize="xsmall" variant="ellipsis">
                {publication.title}
              </Text>
            </Box>
          )}
        </ListItemWithImage>

        <ListItem
          boxProps={{
            border: '1px solid',
            borderTop: 0,
            borderRight: 0,
            padding: 'large',
            alignItems: 'center',
          }}
          disableHover
        >
          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">{title} for {publication.title} - {convertedPublicationDate} Edition</Text>
          </Box>
        </ListItem>
      </Box>

      <ListItem
        boxProps={{
          borderBottom: '1px solid',
          borderTop: '1px solid',
          padding: 'large',
          alignItems: 'center',
        }}
        disableHover
        flexDirection="row"
      >
        <Box flexDirection="row" justifyContent="center">
          <Text color="bodyFontLightColor" fontSize="small" marginRight="auto">
            {/*
             // @ts-expect-error TS2339 */}
            Deadline: {deadlineDate.toFormat('h:mm a')} today
          </Text>

          <Text color="bodyFontLightColor" fontSize="small">
            ({relativeDate})
          </Text>
        </Box>
      </ListItem>
    </Box>
  )
}

export default TodaysDeadlinesListItem
